import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import FAQs from "../components/FAQ/FAQs";
import CardSlider2 from "../components/Slider/CardSlider2";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import HowIt from "../assets/life-savers.svg";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";

const faqData = [
  {
    question:
      "What is Shoora's LifeSavers, and how does it support drivers?",
    answer:
      "Shoora's LifeSavers is a highly trained back-office team that complements our SaaS platform. Our 24/7 Control Room team monitors alerts, engages with drivers during emergencies, and provides immediate assistance to ensure their safety and efficiency.",
  },
  {
    question: "How does Shoora's LifeSavers respond to alerts and emergencies?",
    answer:
      "When an alert is triggered, our system executives immediately engage with the driver through the in-vehicle device's two-way communication system. This direct interaction allows for prompt and effective resolution of issues, minimizing potential risks or delays.",
  },
  {
    question: "What benefits do fleet operators and drivers gain from Shoora's LifeSavers?",
    answer:
      "Shoora's LifeSavers provide 24/7 driver support, emergency assistance, and enhanced fleet safety. Our proactive monitoring and expert intervention minimize accidents, operational delays, and irregularities, elevating safety standards across fleets.",
  },
  {
    question: "How does Shoora's LifeSavers ensure the safety and efficiency of fleet operations?",
    answer:
      "Our state-of-the-art, 24/7 Control Room continuously monitors all alerts, ensuring the safety and efficiency of our operations. Our system executives are on standby at all times, ready to respond swiftly to any incidents or irregularities.",
  },
  {
    question: "Can Shoora's LifeSavers be customized to meet specific fleet operational needs?",
    answer:
      "Yes, Shoora's LifeSavers can be tailored to meet specific fleet operational requirements. Please contact us to discuss how our team can support your unique needs and enhance your fleet's safety and efficiency.",
  }

];



const lifeSaversFeatures = [
  {
    id: 1,
    category: "Feature",
    title: "24/7 Real-Time Monitoring",
    description:
      " Round-the-clock control room for constant vigilance.",
    image:
      "/images/thumbnails/13.jpeg",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 2,
    category: "Feature",
    title: "Two-Way Communication",
    description:
      "Immediate interaction with drivers via in-vehicle devices.",
    image:
      "/images/thumbnails/2.jpeg",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 3,
    category: "Feature",
    title: "Emergency Response",
    description:
      "Rapid assessment and intervention to minimize risks..",
    image:
      "/images/thumbnails/11.jpeg",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 4,
    category: "Feature",
    title: "Expert Support",
    description:
      "Highly trained executives available at all times.",
    image:
      "/images/thumbnails/9.jpeg",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 5,
    category: "Feature",
    title: "Seamless Integration",
    description:
      "Works with existing fleet management systems.",
    image:
      "/images/thumbnails/12.jpeg",
    // link: "#",
    // linkText: "Read more",
  },
];

const ShooraLifeSavers = () => {
  // Function to handle smooth scrolling
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <Page 
      title="Shoora LifeSavers: 24/7 Driver Support, Emergency Assistance, and Fleet Safety"
      description="Shoora's LifeSavers is a highly trained back-office team that complements our SaaS platform. Our 24/7 Control Room team monitors alerts, engages with drivers during emergencies, and provides immediate assistance to ensure their safety and efficiency."
      keywords="Shoora LifeSavers, fleet safety, driver support, emergency response, fleet management, operational efficiency, 24/7 monitoring, driver assistance, fleet operations, fleet management system integration"
    >
      {/* Hero Section */}
      <div className="about-hero hero-2 w-100">
        <img
          src="/images/hero/shoora-life-savers-2.webp"
          alt="Shoora Life Savers Hero"
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6 pe-lg-5">
            <p
              className="fs-6 text-white mt-4"
              style={{ lineHeight: 0.5, marginBottom: "0px !important" }}
            >
              Stay protected with
            </p>
            <h1
              className="text-accent fw-bold mb-4 display-3"
              style={{ lineHeight: 0.9, marginBottom: "0px !important" }}
            >
              Shoora <br />
              <i className="fw-light text-light">LifeSavers</i> <br />
            </h1>
            <p className="fs-5  text-accent">Your Safety, Our Priority.</p>
            <p className="fs-6 text-light mb-5 pe-5">
              A powerful combination of advanced technology and dedicated
              support. Stay protected with 24/7 driver assistance, emergency
              response, and operational excellence.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-light rounded-5">
                Get Started Today
              </button>
              <a
                className="ms-3 btn btn-link text-light fw-bold text-decoration-none"
                href="#cta"
              >
                Get a Demo
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <div className="container-fluid bg-black sticky-top d-none d-lg-block">
        <div className="container nav-links">
          <ul className="navigation-group">
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("overview")}
                className="navigation-item-link btn btn-link text-white"
              >
                Overview
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("howItWorks")}
                className="navigation-item-link btn btn-link text-white"
              >
                How It Works
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("features")}
                className="navigation-item-link btn btn-link text-white"
              >
                Features
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("benefits")}
                className="navigation-item-link btn btn-link text-white"
              >
                Benefits
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("testimonials")}
                className="navigation-item-link btn btn-link text-white"
              >
                Testimonials
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("faqs")}
                className="navigation-item-link btn btn-link text-white"
              >
                FAQs
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Add IDs to the Sections */}
      <section id="overview" className="py-5 bg-black text-accent">
        <div className="container">
          <h2 className="text-center fw-bold mb-4">
            Elevating Safety Standards Across Fleets
          </h2>
          <p className="text-center mb-5">
            Shoora Life Savers is a comprehensive solution combining a
            state-of-the-art SaaS platform and a highly trained back-office
            team. Our 24/7 Control Room monitors alerts, engages with drivers
            during emergencies, and provides immediate support to ensure safety
            and operational efficiency.
          </p>
        </div>
      </section>

      <section className="container-fluid bg-black" id="howItWorks">
        <div className="container">
            <h1 className="text-center text-light display-5 my-5 fw-bold">How It Works</h1>
          <img
            src={HowIt}
            alt="shoora life savers how it works"
            className="w-100"
          />
        </div>
      </section>

      {/* Benefits Section */}

      <section id="features" className="py-5">
        <CardSlider2 data={lifeSaversFeatures} />
      </section>

      <section id="benefits" className="py-5">
        <CardContainer heading="Why Choose Shoora Life Savers?" desc="Discover how this solution drives business success while making roads safer.">
          <Card
            // category="Safety"
            bgColor="#f4f4f4"
            type="primary"
            headingColor="#0d004a"
            heading="Driver Support, Anytime"
            desc="Immediate assistance during critical situations ensures safety, peace of mind, and swift support to drivers and fleet operators whenever and wherever needed, reducing stress and ensuring timely help."
            imgsrc="https://images.pexels.com/photos/3325651/pexels-photo-3325651.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Fleet Safety Assurance"
            desc="Minimized accidents and delays through proactive monitoring, ensuring safer fleet operations, protecting drivers, vehicles, and cargo with timely interventions and support always."
            imgsrc="https://images.pexels.com/photos/3997045/pexels-photo-3997045.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          />
          <Card
            // category="Coaching insights"
            type="primary"
            heading="Optimized Operations"
            desc="Reduced risks, faster resolution times, and enhanced driver accountability streamline fleet operations, boosting efficiency and productivity with data-driven insights and proactive support always available."
            imgsrc="https://images.pexels.com/photos/936135/pexels-photo-936135.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
            // linkText="See Plans & Pricing"
          />
        </CardContainer>
      </section>

      

      <section id="testimonials" className="py-5">
        <div className="testimonials-section section">
          <div className="container">
          <Testimonials/>
          </div>
        </div>
      </section>

      <section id="faqs" className="py-5">
        <FAQs
          data={faqData}
          title="Your questions about ShooraLifeSavers, answered."
        />
      </section>
    </Page>
  );
};

export default ShooraLifeSavers;
